import { observer } from "mobx-react-lite"

import { useScaleApplication } from "@/domains/application/use-scale-application"
import { ApprovalMode } from "@/domains/core"

import { SettingsSectionLayout } from "./settings-section-layout"

export const ApprovalModeSettingsSection = observer(() => {
  const scaleApp = useScaleApplication()
  return (
    <SettingsSectionLayout title="Approval Mode" description="Choose your preferred approval mode">
      <div className="space-y-2">
        <div className="flex-col space-y-2">
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              id="infinite"
              name="approvalMode"
              value="infinite"
              checked={scaleApp?.Settings.approvalMode === "infinite"}
              onChange={(e) => scaleApp?.Settings.setApprovalMode(e.target.value as ApprovalMode)}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500"
            />
            <label htmlFor="infinite" className="text-t100 text-sm font-medium">
              Infinite
            </label>
          </div>
          <Description>Infinite approvals are simpler with less transactions but have higher risk.</Description>
        </div>
        <div className="flex-col space-y-2">
          <div className="flex items-center space-x-2">
            <input
              type="radio"
              id="strict"
              name="approvalMode"
              value="strict"
              checked={scaleApp?.Settings.approvalMode === "strict"}
              onChange={(e) => scaleApp?.Settings.setApprovalMode(e.target.value as ApprovalMode)}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500"
            />
            <label htmlFor="strict" className="text-t100 text-sm font-medium">
              Strict
            </label>
          </div>
          <Description>Exact approvals require more transactions but are safer and more precise.</Description>
        </div>
      </div>
    </SettingsSectionLayout>
  )
})

const Description = ({ children }: { children: React.ReactNode }) => {
  return <div className="text-t200 ml-6 max-w-sm text-sm">{children}</div>
}
